module.exports = __webpack_public_path__ + "static/img/025家居合集.0630cd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/025家居合集.jpg
// module id = pkJD
// module chunks = 0